export default {"src":"/_next/static/media/kanosport.d647c610.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};